import { Button } from '@design';
import React from 'react';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../Shared.module.scss';
import styles from './ScenarioNoConditions.module.scss';

export interface ScenarioNoConditionsProps {
  addConditionsOnClick?: () => void;
}

export const ScenarioNoConditions = ({
  addConditionsOnClick,
}: ScenarioNoConditionsProps) => {
  const { t } = useTranslation('scenario');

  return (
    <div className={sharedStyles.container}>
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <div className={styles.labelAndButtonWrapper}>
        <div className={sharedStyles.description} data-testid="scenario-no-conditions">
          <p className={sharedStyles.title}>
            {t('scenario:emptyState:noConditionsTitle')}
          </p>
          <p className={sharedStyles.message}>
            {t('scenario:emptyState:noConditionsMessage')}
          </p>
        </div>
        {addConditionsOnClick && (
          <Button
            className={sharedStyles.styledButton}
            data-testid="add-condition-button"
            variant="secondary"
            size="medium"
            label={t('scenario:emptyState.addCondition')}
            onClick={addConditionsOnClick}
          />
        )}
      </div>
    </div>
  );
};
